/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import WelcomeAdvice from 'Docs/welcome-advice.mdx';
import {Button, Section} from '@dnb/eufemia/src';
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    ul: "ul",
    li: "li",
    code: "code",
    h2: "h2",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Getting Started"
    }), "\n", _jsx(_components.p, {
      children: "There are several ways to get started depending on what you want to do."
    }), "\n", _jsx(_components.p, {
      children: "Do you want to..."
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "simply use the HTML Elements right away?"
      }), "\n", _jsx(_components.li, {
        children: "customize the core DNB brand style and behavior?"
      }), "\n", _jsx(_components.li, {
        children: "use the basis and create theme on top?"
      }), "\n", _jsxs(_components.li, {
        children: ["make changes to the overall ", _jsx(_components.code, {
          children: "ui-lib"
        }), "?"]
      }), "\n", _jsx(_components.li, {
        children: "change contents of the Eufemia Design System Portal (website)?"
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "So, how do I get started?"
    }), "\n", _jsxs(_components.p, {
      children: ["You can ", _jsx(_components.a, {
        href: "/uilib/intro",
        children: "follow an intro"
      }), ", guiding you through all the elementary parts of Eufemia."]
    }), "\n", _jsx(Section, {
      style_type: "mint-green",
      spacing: true,
      align: "center",
      children: _jsx(Button, {
        href: "/uilib/intro",
        size: "large",
        text: "Quick Intro"
      })
    }), "\n", _jsx(_components.h2, {
      children: "Code Editor Extensions"
    }), "\n", _jsxs(_components.p, {
      children: ["You may be interested to install an ", _jsx(_components.a, {
        href: "/uilib/helpers/tools/#code-editor-extensions",
        children: "Eufemia code editor extension"
      }), "."]
    }), "\n", _jsx(WelcomeAdvice, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
